{
  "actionbar.actions": "Działania",
  "actionbar.actionsAvailable": "Dostępne działania.",
  "actionbar.clearSelection": "Wyczyść zaznaczenie",
  "actionbar.selected": "Zaznaczono: {count}",
  "actionbar.selectedAll": "Wszystkie zaznaczone",
  "button.pending": "oczekujące",
  "calendar.invalidSelection": "{selectedCount, plural, one {Wybrana data jest niedostępna} other {Wybrane daty są niedostępne}}.",
  "contextualhelp.help": "Pomoc",
  "contextualhelp.info": "Informacja",
  "datepicker.endTime": "Godzina końcowa",
  "datepicker.startTime": "Godzina początkowa",
  "datepicker.time": "Godzina",
  "dialog.alert": "Ostrzeżenie",
  "dialog.dismiss": "Zignoruj",
  "dropzone.replaceMessage": "Upuść plik, aby zastąpić",
  "inlinealert.informative": "Informacja",
  "inlinealert.negative": "Błąd",
  "inlinealert.notice": "Ostrzeżenie",
  "inlinealert.positive": "Powodzenie",
  "label.(optional)": "(opcjonalne)",
  "label.(required)": "(wymagane)",
  "menu.moreActions": "Więcej akcji",
  "picker.placeholder": "Zaznacz…",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.loading": "Ładowanie...",
  "table.loadingMore": "Wczytywanie większej liczby...",
  "table.resizeColumn": "Zmień rozmiar kolumny",
  "table.sortAscending": "Sortuj rosnąco",
  "table.sortDescending": "Sortuj malejąco",
  "tag.actions": "Działania",
  "tag.hideButtonLabel": "Wyświetl mniej",
  "tag.noTags": "Brak",
  "tag.showAllButtonLabel": "Pokaż wszystko ({tagCount, number})",
  "breadcrumbs.more": "Więcej elementów",
  "combobox.noResults": "Brak wyników",
  "notificationbadge.indicatorOnly": "Nowa aktywność",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}